import {FC} from 'react'

import {useTranslation} from '@/i18n'

import {CardListLayout} from '../../cards/CardListLayout'
import {CardWrapper} from '../../cards/CardWrapper'
import {HowItWorksStepType} from '../HowItWorks'
import {HowItWorksStep} from '../step/HowItWorksStep'

type HowItWorksProps = {
  title: string
  steps: HowItWorksStepType[]
  isCentered?: boolean
}

export const HowItWorks: FC<React.PropsWithChildren<HowItWorksProps>> = ({
  title,
  steps,
  isCentered,
}) => {
  const {t} = useTranslation()

  return (
    <>
      <CardListLayout title={title}>
        {steps.map(({title, duration, description, imageSrc, imageAlt}) => (
          <CardWrapper key={title} numOfCardsPerRow={4} isHoverable={false} hasBorder={false}>
            <HowItWorksStep
              title={t(title)}
              duration={t(duration)}
              description={t(description)}
              imageSrc={imageSrc}
              imageAlt={imageAlt}
              isCentered={isCentered}
            />
          </CardWrapper>
        ))}
      </CardListLayout>
    </>
  )
}
